import React from 'react';
import { ReactFlow, Controls, Background } from '@xyflow/react';
import KingdomSelector from './Components/KingdomSelector.jsx'
import TechnologyCardNode from './Components/TechnologyCardNode.jsx'

import '@xyflow/react/dist/style.css';
import GetCharactersList from './KW/Characters.jsx'
import GetCharacterTreeAsFlow from './KW/TechnologyTree.jsx';

const nodeTypes = { technologyCard: TechnologyCardNode };

class App extends React.Component {

  state = {
    selectedFaction: "loargen",
    selectedCharacter: "arnold"
  }

  UpdateSelectedCharacter = (newSelectedFaction, newSelectedCharacter) => {
    this.setState({'selectedFaction': newSelectedFaction, 'selectedCharacter': newSelectedCharacter});
  }

  render()
  {
    let characters = GetCharactersList();
    let tree = GetCharacterTreeAsFlow(this.state.selectedCharacter, "technologyCard");

    return (
      <div>
        <KingdomSelector characters={characters} selectedCharacter={this.state.selectedCharacter} onKingdomSelected={this.UpdateSelectedCharacter}/>
        <div style={{ width: '1080px', height: '720px' }}>
          <ReactFlow
            nodes={tree.nodes}
            edges={tree.edges}
            nodeTypes={nodeTypes} >
            <Background />
            <Controls />
          </ReactFlow>
        </div>
      </div>
    );
  }
}

export default App;